var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 486.586,
    y: 111.082,
    width: 558.145,
    height: 558.145,
    transform: "rotate(45 486.586 111.082)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 226.782,
    y: 244.778,
    width: 517.272,
    height: 517.272,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 486.599,
    y: 127.568,
    width: 534.848,
    height: 534.848,
    transform: "rotate(45 486.599 127.568)",
    fill: "#f42"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 237.64,
    y: 255.684,
    width: 495.681,
    height: 495.681,
    fill: "#f42"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 487.193,
    y: 198.978,
    width: 433.875,
    height: 433.875,
    transform: "rotate(45 487.193 198.978)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M625.27 451.278C635.622 431.236 643.47 349.712 625.8 319.526C608.131 289.341 570.951 241.485 483.707 240.013C396.463 238.54 370.947 285.179 359.154 295.185C347.361 305.191 330.484 343.121 329.492 379.524C328.501 415.926 330.833 432.024 338.3 446.895C336.52 415.943 348.138 416.078 347.135 386.524C351.468 412.969 349.678 435.152 350.136 439.834C350.997 448.641 341.838 458.491 342.809 480.021C343.78 501.551 352.416 514.911 349.914 525.537C347.411 536.163 339.256 551.736 342.35 565.429C345.443 579.122 355.234 588.252 360.387 590.093C365.541 591.933 371.799 593.865 376.585 590.093C395.727 575 446.159 578.722 449.104 583.303C452.049 587.884 450.944 604.081 449.104 607.026C447.263 609.971 434.673 618.555 432.546 628.389C430.42 638.224 430.714 660.87 432.546 664.318C434.379 667.766 444.301 676.286 446.636 674.885C448.971 673.483 453.247 656.428 454.385 653.751C454.937 656.679 454.074 679.678 454.385 680.52C454.696 681.362 467.393 684.596 468.474 684.043C469.556 683.49 472.088 670.011 472.701 667.84C473.715 671.639 473.908 688.614 475.155 689.165C476.402 689.716 488.446 690.157 489.426 689.165C490.407 688.173 491.182 654.53 492.052 651.501C493.118 654.303 495.373 688.665 496.875 690.229C498.377 691.794 512.148 691.857 514.026 689.604C515.904 687.35 515.542 668.532 516.225 665.458C517.25 668.418 518.551 681.589 520.286 682.843C524.354 685.785 535.371 677.147 537.061 675.207C538.751 673.266 540.592 657.335 541.12 655.144C542.129 656.93 543.781 666.193 546.282 665.924C548.783 665.654 561.485 662.751 561.629 656.718C561.773 650.685 562.27 624.714 554.882 618.114C547.495 611.515 528.361 607.405 527.65 601.62C526.94 595.834 534.929 584.815 541.74 577.667C548.551 570.519 589.967 577.766 596.807 581.13C606.049 585.676 618.786 595.728 633.347 581.562C647.908 567.396 636.953 566.993 636.6 541.707C636.248 516.42 649.232 500.467 616.266 457.929C607.861 447.084 611.175 411.414 619.544 391.372C617.121 418.462 625.711 427.272 625.27 451.278Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M518.456 506.805C526.713 490.841 521.733 486.416 545.398 478.043C570.256 469.247 599.792 473.018 612.026 484.96C627.317 499.888 621.492 520.276 614.21 535.204C607.476 549.009 581.189 551.072 552.68 546.49C532.291 543.214 512.995 517.364 518.456 506.805Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M469.305 504.985C459.956 479.13 450.736 474.766 404.862 474.402C382.024 474.22 367.343 481.704 365.123 520.88C364.084 539.209 372.37 538.977 389.754 552.756C399.764 560.69 439.814 547.219 449.159 540.44C463.339 530.155 472.847 514.781 469.305 504.985Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M471.458 581.697C481.669 561.469 485.689 538.225 492.573 538.287C501.733 538.37 509.412 559.959 517.144 578.858C522.287 591.43 514.858 613.144 510.287 616.573C503.324 621.795 501.144 610.287 494.858 611.43C488.573 612.573 482.251 626.258 473.744 615.982C464.867 605.26 463.834 596.799 471.458 581.697Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M531.774 734.869C528.34 730.944 471.66 732.467 467.735 734.43C463.019 736.788 456.887 744.184 456.718 755.963C456.63 762.03 476.881 771.502 488.114 766.265C497.006 762.119 498.416 762.341 506.265 768.718C514.114 775.095 527.85 768.718 536.68 762.831C545.51 756.944 540.254 744.56 531.774 734.869Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkull);
export default __webpack_public_path__ + "static/media/Skull.52cedd667010dd984040e32055ad574f.svg";
export { ForwardRef as ReactComponent };